import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-limit-status-dialog',
  templateUrl: './limit-status-dialog.component.html',
  styleUrls: ['./limit-status-dialog.component.css']
})
export class LimitStatusDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string,
      messages: string,
      isConnectionLost?: boolean
    }
  ) { }

  ngOnInit(): void {}
}
